


























import SpecialNavbar from "@/navbars/SpecialNavbar.vue";
import Helper from "../services/errorHelper";
import Component from "vue-class-component";
import Vue from "vue";
import { RawLocation, Route } from "vue-router";
import { getStaticConfiguration } from "@/config/app";

@Component({
  components: {
    SpecialNavbar,
  },
})
export default class NotFound extends Vue {
  homeRoute = "news";
  mounted(): void {
    getStaticConfiguration().then(({ HOME_ROUTE }) => {
      this.homeRoute = HOME_ROUTE || "news";
    });
  }
  beforeRouteLeave(
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void
  ) {
    Helper.clear();

    next();
  }
}
